export const getImagesSrcFromHtml = (html) => {
  const elem = document.createElement('div');
  elem.style.display = 'none';
  elem.innerHTML = html;
  const images = Array.prototype.slice.call(elem.getElementsByTagName('img'));
  return images.map(i => i.src);
};
